var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{ref:"appConfirmationModal",attrs:{"title":_vm.title,"ok-title":"Bestätigen","cancel-title":"Abbrechen"},on:{"ok":_vm.confirm}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.message)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d96e905","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/misc/ConfirmModal.vue
// module id = 810
// module chunks = 1